import url from './url'
const AppConsts= {
    userManagement:{
        defaultAdminUserName: 'admin'
    },
    localization:{
        defaultLocalizationSourceName: 'Riesgo'
    },
    authorization:{
        encrptedAuthTokenName: 'enc_auth_token'
    },
    setting: { 
        shrink: false,
        confirmLeave: false,
        nroTabs: 4,
        timeout: 240000,
        appName: 'Riesgo Financiero',
    },
    appBaseUrl: "http://localhost:8080",
    remoteServiceBaseUrl: url

}
export default AppConsts